import { render, staticRenderFns } from "./GridCardComponent.vue?vue&type=template&id=75739ef4&scoped=true"
import script from "./GridCardComponent.vue?vue&type=script&lang=js"
export * from "./GridCardComponent.vue?vue&type=script&lang=js"
import style0 from "./GridCardComponent.vue?vue&type=style&index=0&id=75739ef4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75739ef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75739ef4')) {
      api.createRecord('75739ef4', component.options)
    } else {
      api.reload('75739ef4', component.options)
    }
    module.hot.accept("./GridCardComponent.vue?vue&type=template&id=75739ef4&scoped=true", function () {
      api.rerender('75739ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/work_environments/GridCardComponent.vue"
export default component.exports